import { render, staticRenderFns } from "./topButton.vue?vue&type=template&id=52d105b1&lang=pug&"
import script from "./topButton.vue?vue&type=script&lang=js&"
export * from "./topButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports